import FundingCard from '@assets/images/login/funding-card.png'
import LoginChart from '@assets/images/login/login-chart.png'
import NewFeature from '@assets/images/login/new-feature.png'
import Vector from '@assets/images/login/vector.svg?react'
import cn from 'classnames'
import Text from '../Common/Text'
import styles from './LoginBanner.module.scss'

interface IProps {
  /**
   * Renders the banner as a flex panel that fills its parent, rather than the
   * full-viewport right half it occupies on the auth pages. Used by the
   * data-room-closed screen, which sits inside the shell's content area.
   */
  isPanel?: boolean
}

const LoginBanner = ({ isPanel = false }: IProps) => {
  return (
    <div className={cn(styles.container, { [styles.panel]: isPanel })}>
      <div className={styles.content}>
        <div className={styles.textContent}>
          <Text variant="hero" casing="sentence" component="span">
            Powerful <span className={styles.highlighted}>Lending</span>,
            <br />
            Seamlessly integrated.
          </Text>
          <span className={styles.subtitle}>
            <Text variant="bodyLg" component="span">
              {`Atlas is more than a funding platform. It's your growth engine.`}
              <br />
              Quick access, real-time insights, and seamless integration into your workflow.
            </Text>
          </span>
        </div>
        <div className={styles.floatingElements}>
          <div className={styles.floatingElement1}>
            <img src={NewFeature} alt="Welcome notification" />
          </div>

          <div className={styles.floatingElement2}>
            <img src={FundingCard} alt="Loan balance widget" />
          </div>

          <div className={styles.floatingElement3}>
            <img src={LoginChart} alt="Total collections chart" />
          </div>
        </div>
      </div>
      <Vector className={styles.vector} />
    </div>
  )
}

export default LoginBanner
